import { PaymentStatement, PaymentStatementProduct, RefundStatus } from './paymentStatement';
import { SalesChannelOrder } from './sales-channels';

export enum PaymentStatementScheduleStatus {
  READY = 'ready',
  CANCEL = 'cancel',
  COMPLETED = 'completed',
}

export interface ProgramScheduleUser {
  id?: string;
  name: string;
  phone: string;
}

export interface PaymentStatementScheduleInfo {
  name?: string;
  birthYear?: string;
  friends?: string[];
  [key: string]: any;
}

export interface PaymentStatementSchedule {
  id: string;
  scheduleName: string;
  startDate: Date;
  endDate: Date;
  localDateString: string;
  week: number;
  duration: number;
  scheduleInfo: PaymentStatementScheduleInfo;
  inputOption?: string;
  status: PaymentStatementScheduleStatus;
  optionName?: string;
  instructor?: ProgramScheduleUser;
}

export interface ProgramSchedule {
  _id: string;
  partnerId: string;
  partnerName: string;
  product: PaymentStatementProduct;
  representative: ProgramScheduleUser;
  schedule: PaymentStatementSchedule;
  refundStatus?: RefundStatus;
  sourceId: string;
  source: string;
  sourceName?: string;
  createdAt: Date;
  updatedAt: Date;
  notes?: string;
}

export interface GetProgramSchedule extends ProgramSchedule {
  paymentStatement?: PaymentStatement;
  salesChannelOrder?: SalesChannelOrder;
}

export interface ProgramScheduleSearchQuery {
  keyword?: string;
  page?: number;
  size?: number;
  sort?: string;
  startDate?: Date;
  endDate?: Date;
}

export interface ProgramScheduleGroup {
  _id: string;
  name: string;
  memo?: {
    partner: string;
    instructor: string;
  };
  scheduleIds?: string[];
  product?: PaymentStatementProduct;
  optionName?: string;
  partnerId?: string;
  instructor?: {
    id: string;
    name: string;
    phone?: string;
    nickname?: string;
  };
  startDate?: Date;
  endDate?: Date;
  studentsMin?: number;
  confirmedAt?: Date;
  createdAt: Date;
  updatedAt: Date;
}

export interface GetProgramScheduleGroup extends ProgramScheduleGroup {
  schedules?: ProgramSchedule[];
}
